<style lang="less">
.contentH .page-content {
  height: 350px;
}
.echart-main {
  width: 100%;
  height: 400px;
}
.content-bg{
  background: #fff;
}
</style>
<template>
  <div>
    <div class="page-main">
      <div class="page-main-top" v-loading="devicesPageLoading">
        <el-row :gutter="20">
          <el-col :span="7" class="contentH">
            <information-list :list="basicInfo" :right="16" :left="8"></information-list>
          </el-col>
          <el-col :span="17">
            <position-map :marker-point="markerPoint" :icon-status="iconStatus"></position-map>
          </el-col>
        </el-row>
      </div>
      <div class="page-main-bottom">
        <div class="content-list content-bg">
          <el-row>
            <el-col :span="type==='AirosolData'?12:24" v-loading="realTimeLoading">
                <information-list
                  :list="realTimeData"
                  :isDownId="isDownId"
                  :isDown="isDown"
                  :title="'实时数据'"
                ></information-list>
            </el-col>
            <el-col :span="12" v-if="type==='AirosolData'" v-loading="airosolStatusLoading">
                <information-list
                  :list="airosolStatusDataList"
                  :isDownId="isDownId"
                  :isDown="isDown"
                  :title="' '"
                ></information-list>
            </el-col>
          </el-row>
        </div>
        
        <div class="content-list" v-if="type==='EMagneticData2'">
          <div class="page-content">
            <div class="title">
              <el-row>
                <el-col
                  :span="12"
                >{{ electricIntensity.titleTime }}{{ electricIntensity.title ? electricIntensity.title : "" }}数据</el-col>
                <el-col :span="12" class="text-right echart-tab-btn">
                  <!-- 刻度1分钟 -->
                  <el-button
                    type="primary"
                    size="small"
                    :plain="electricIntensity.attribute+'-1m'!=electricIntensity.isClass?true:false"
                    @click="timeSlot('最近1个小时', electricIntensity.attribute, 0,'1m',true)"
                  >最近1个小时</el-button>
                  <!-- 刻度5分钟 -->
                  <el-button
                    type="primary"
                    size="small"
                    :plain="electricIntensity.attribute+'-5m'!=electricIntensity.isClass?true:false"
                    @click="timeSlot('最近1天', electricIntensity.attribute, -1,'5m',true)"
                  >最近1天</el-button>
                  <!-- 刻度1小时 -->
                  <el-button
                    type="primary"
                    size="small"
                    :plain="electricIntensity.attribute+'-1h'!=electricIntensity.isClass?true:false"
                    @click="timeSlot('最近1周', electricIntensity.attribute, -7,'1h',true)"
                  >最近1周</el-button>
                </el-col>
              </el-row>
            </div>
            <div class="content">
              <div :id="electricIntensity.attribute" class="echart-main"></div>
            </div>
          </div>
          <!-- <echarts-option
            :option-data="item"
            :date-time="dateTime"
            v-on:selectTimeSlot="selectTimeSlot"
          ></echarts-option>-->
        </div>
        <div v-if="type!=='HpgeData'">
          <div class="content-list" v-for="(item, index) in optionData" :key="index">
            <div class="page-content">
              <div class="title">
                <el-row>
                  <el-col :span="12">{{ item.titleTime }}{{ item.title ? item.title : "" }}数据</el-col>
                  <el-col :span="12" class="text-right echart-tab-btn">
                    <!-- 刻度1分钟 -->
                    <el-button
                      type="primary"
                      size="small"
                      :plain="item.attribute+'-1m'!=item.isClass?true:false"
                      @click="timeSlot('最近1个小时', item.attribute, 0,'1m')"
                    >最近1个小时</el-button>
                    <!-- 刻度5分钟 -->
                    <el-button
                      type="primary"
                      size="small"
                      :plain="item.attribute+'-5m'!=item.isClass?true:false"
                      @click="timeSlot('最近1天', item.attribute, -1,'5m')"
                    >最近1天</el-button>
                    <!-- 刻度1小时 -->
                    <el-button
                      type="primary"
                      size="small"
                      :plain="item.attribute+'-1h'!=item.isClass?true:false"
                      @click="timeSlot('最近1周', item.attribute, -7,'1h')"
                    >最近1周</el-button>
                  </el-col>
                </el-row>
              </div>
              <div class="content">
                <div :id="item.attribute" class="echart-main"></div>
              </div>
            </div>
            <!-- <echarts-option
            :option-data="item"
            :date-time="dateTime"
            v-on:selectTimeSlot="selectTimeSlot"
            ></echarts-option>-->
          </div>
        </div>
        <div v-else>
          <div class="content-list">
             <div class="page-content">
              <div class="title">实时谱图</div>
              <div>
                <statistics-echarts-option
                  :echart-id="'echart1'"
                  :option-data="spectrogramOptionData"
                  :pageLoading="spectrogramLoading"
                  :isDot="isDot"
                  :formatters="hpgeDataFormatter"
                ></statistics-echarts-option>
                    <!-- v-on:searchZoom="search"
                  :startTime="ruleForm.startTime"
                  :endTime="ruleForm.endTime" -->
              </div>
             </div>
          </div>
          <div class="content-list" v-loading="nuclideLoading">
            <div class="page-content">
              <div class="title">数据解析</div>
              <div class="content">
                <div v-loading="nuclideLoading" v-if="nuclideData.length">
                  <nuclide-table :tableData="nuclideData" :titleTableData="titleNuclideData"></nuclide-table>
                </div>
                <div v-if="!nuclideData.length" class="no-data font-color-no text-center">暂无数据</div>
              </div>
            </div>
            <!-- <information-list :list="nuclideData" :title="'最新核素分析报告'"></information-list> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import positionMap from "@/components/positionMap"; //地图信息
import informationList from "@/components/informationList"; //信息展示
import echartsOption from "@/components/echartsOption"; //echarts
import nuclideTable from "@/components/nuclideTable"; //核素数据展示
import statisticsEchartsOption from "@/components/statisticsEchartsOption"; //echarts渐变折线
export default {
  name: "hpicSystem", //高压电离室
  components: {
    positionMap: positionMap,
    informationList: informationList,
    echartsOption: echartsOption,
    nuclideTable: nuclideTable,
    statisticsEchartsOption:statisticsEchartsOption
  },
  data() {
    return {
      devicesPageLoading: true, //设备基本信息loading
      realTimeLoading: true, //实时数据loading
      nuclideLoading: true, //核素分析报告loading
      airosolStatusLoading:true,//全自动气溶胶 Status 数据loading
      spectrogramLoading:true,//实时谱图loading
      isDown: false, //是否有下载
      isDot:false,//是否要圆点
      markerPoint: { lng: 116.404, lat: 39.915 },
      dataFieldList: [], //实时数据单位/title
      setIntervalId: null,
      dateTime: "",
      hpgeDataFormatter:(params)=>{
        // console.log("pa", params);
        let html = `
            <div class="tooltip-box">
            多道道数: ${params[0].name} <br>
            计数: ${params[0].value}
            </div>
        `;
        return html;
      },
      spectrogramOptionData: {
        title: "最新谱图",
        // attribute: '',
        unit: "",
        dataX: [],
        dataY: [],
      },//实时谱图
      optionData: {},
      // newOptionData:{},
      notifys: null, //提示窗口
      option: {
        tooltip: {
          trigger: "axis",
          // formatter: function (params) {
          //   // console.log(params[0]);
          //   let html = `
          //       <div class="tooltip-box">
          //       ${params[0].name} <br>
          //       ${params[0].marker}${params[0].seriesName}: ${params[0].value}
          //       </div>
          //   `;
          //   return html;
          // },
        },
        grid: {
          // width: "100%",
          // containLabel: true,
        },
        legend: {
          data: [],
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: [],
        },
        yAxis: {
          name: "",
          type: "value",

          splitLine: {
            show: false, // X轴 网格线 颜色类型的修改
          },
        },
        series: [],
      },
      electricIntensity: {}, //电场强度echart
      deviceType: "", //设备typeid
      basicInfo: [
        {
          name: "设备名称",
          attribute: "name",
          value: "",
        },
        {
          name: "设备型号",
          attribute: "device_type_name",
          value: "",
        },
        {
          name: "设备描述",
          attribute: "desc",
          value: "",
        },
        {
          name: "SN",
          attribute: "device_sn",
          value: "",
        },
      ], //基本信息
      realTimeData: [], //实时数据
      airosolStatusDataList:[],//全自动气溶胶 Status 数据
      nuclideData: [], //核素分析数据
      titleNuclideData: [],
      isDownId: 0, //核素下载ID
      iconStatus:0
    };
  },
  computed: {
    id: function () {
      return this.$route.params.id || ""; //设备id
    },
    stationId: function () {
      return this.$route.params.stationId || ""; //自动站id
    },
    type: function () {
      return this.$route.params.type || ""; //设备type
    },
  },
  methods: {
    //基本信息
    getDateil() {
      this.$$http("automaticStationInfo", {
        id: this.stationId,
      }).then((results) => {
          this.devicesPageLoading = false;
          if (results.data && results.status == 200) {
            //坐标点
            this.markerPoint = { 
              lng: results.data.lng, 
              lat: results.data.lat
            };
            this.iconStatus = results.data.status;
            //基本信息
            let deviceType = "";
            for (let i in results.data.devices) {
              if (results.data.devices[i].id == this.id) {
                window.document.title = results.data.devices[i].name
                  ? results.data.devices[i].name
                  : "";
                deviceType = results.data.devices[i].device_type;
                for (let j in this.basicInfo) {
                  this.basicInfo[j].value =
                    results.data.devices[i][this.basicInfo[j].attribute];
                }
              }
            }
            this.deviceType = deviceType;
            console.log("deviceType", deviceType);

            let _realTimeDataField = this.getRealTimeData(deviceType);
            if (this.type !== "HpgeData") {
              //当设备不是高纯锗能谱仪系统调用echart相关数据接口
              let _getEchartsData = this.pbFunc.echartsData(
                this.id,
                this.type,
                "",
                "",
                "",
                this.type == "LABRData" ? "5m" : "1m"
              );
              Promise.all([_realTimeDataField, _getEchartsData]).then((res) => {
                this.devicesPageLoading = false;
                // console.log("list", res);
                if (res[0]) {
                  let echartList = res[1];
                  for (let i in echartList) {
                    let attributeArr = Object.keys(echartList[i]);
                    for (let j in attributeArr) {
                      if (
                        attributeArr[j] !== "data_time" &&
                        this.optionData[attributeArr[j]]
                      ) {
                        this.optionData[attributeArr[j]].dataY.push(
                          echartList[i][attributeArr[j]]
                        );
                        this.optionData[attributeArr[j]].dataX.push(
                          echartList[i].data_time
                        );
                      }
                    }
                    if (this.type === "EMagneticData2") {
                      this.electricIntensity.dataYList.electric.push(
                        echartList[i].electric
                      );
                      this.electricIntensity.dataYList.electric_savg.push(
                        echartList[i].electric_savg
                      );
                      this.electricIntensity.dataYList.electric_avg.push(
                        echartList[i].electric_savg
                      );
                      this.electricIntensity.dataX.push(
                        echartList[i].data_time
                      );
                    }
                  }

                  setTimeout(() => {
                    if (this.type === "EMagneticData2") {
                      this.setEchart(this.electricIntensity, "EMagneticData2");
                    }
                    for (let i in this.optionData) {
                      // console.log('this.optionData[i]',this.optionData[i])
                      this.setEchart(this.optionData[i]);
                    }
                  }, 1000);
                }
              });
            }
            resolve(results);
          } else {
            this.$message.error(
              results.data.msg ? results.data.msg : "获取自动站信息失败"
            );
            reject(results);
          }
        }).catch((err,res) => {
          // console.log('err',err.response.status)
          if(err.response&&err.response.status === 404){
            this.$message.error("无数据！");
            this.realTimeLoading = false;
          }
          this.devicesPageLoading = false;
        });
    },
    //实时数据
    getRealTimeData(deviceType,isUpdate) {
      // console.log('optionData',this.optionData)
      return new Promise((resolve, reject) => {
        this.$$http("realTimeDatas", {
          device: this.id,
          device_data_model: this.type,
        })
          .then((results) => {
            this.realTimeLoading = false;
            if (results.data && results.status == 200) {
              this.dataFieldList = [];
              for (let i in results.data) {
                if (i == "status") {
                  this.dataFieldList.push({
                    name: "状态",
                    attribute: i,
                    unit: "",
                    value: results.data[i] == 1 ? "在线" : "离线",
                  });
                } else if (i !== "id" && i !== "status") {
                  this.dataFieldList.push({
                    name: i === "data_time" ? "更新时间" : "",
                    attribute: i,
                    unit: "",
                    value: results.data[i] + "",
                  });
                }
                //高纯锗能谱仪系统下载ID
                if (this.type === "HpgeData") {
                  // console.log("id", results.data.id);
                  this.isDownId = results.data.id;
                  
                }
              }

              // if(!isUpdate){
                this.realTimeDataField(deviceType,isUpdate).then((res) => {
                  resolve(results.data);
                });
              // }
            } else {
              this.$message.error(
                results.data.msg ? results.data.msg : "获取设备实时数据失败"
              );
              reject(null);
            }
          })
          .catch((err) => {
            this.realTimeLoading = false;
          });
      });
    },
    //实时数据单位
    realTimeDataField(type,isUpdate) {
      return new Promise((resolve, reject) => {
        this.$$http("realTimeDataField", {
          device_type: type,
        })
          .then((results) => {
            if (results.data && results.status == 200) {
              for (let i in results.data.results) {
                for (let j in this.dataFieldList) {
                  if (
                    this.dataFieldList[j].attribute ==
                    results.data.results[i].name
                  ) {
                    this.dataFieldList[j].name = results.data.results[i].title;
                    this.dataFieldList[j].unit = results.data.results[i].unit;
                    if (results.data.results[i].unit)
                      this.dataFieldList[j].value =
                        this.dataFieldList[j].value +
                        results.data.results[i].unit;
                  }
                }
                //当chart_field为true，有图表数据
                if (results.data.results[i].chart_field&&!isUpdate) {
                  //电磁辐射在线监测系统 特殊处理三根线
                  if (this.type === "EMagneticData2") {
                    if (
                      results.data.results[i].name === "temperature" ||
                      results.data.results[i].name === "humidity" ||
                      results.data.results[i].name === "battery"
                    ) {
                      this.optionData[results.data.results[i].name] = {
                        title: results.data.results[i].title,
                        titleTime: "最近1个小时",
                        isClass: results.data.results[i].name + "-1m",
                        attribute: results.data.results[i].name,
                        unit: results.data.results[i].unit,
                        option: this.option,
                        dataX: [],
                        dataY: [],
                      };
                    } else if (results.data.results[i].name === "electric") {
                      this.electricIntensity = {
                        title: results.data.results[i].title,
                        titleTime: "最近1个小时",
                        isClass: results.data.results[i].name + "-1m",
                        attribute: results.data.results[i].name,
                        unit: results.data.results[i].unit,
                        option: this.option,
                        dataX: [],
                        legend: ["电场强度", "6分钟平均值", "6分钟平均方根值"],
                        dataYList: {
                          electric: [],
                          electric_savg: [],
                          electric_avg: [],
                        },
                      };
                    }
                  } else if (this.type !== "HpgeData") {
                    //高纯锗能谱仪系统没有图表
                    this.optionData[results.data.results[i].name] = {
                      title: results.data.results[i].title,
                      titleTime: "最近1个小时",
                      isClass: results.data.results[i].name + "-1m",
                      attribute: results.data.results[i].name,
                      unit: results.data.results[i].unit,
                      option: this.option,
                      dataX: [],
                      dataY: [],
                    };
                  }
                }
              }
              this.realTimeData = this.pbFunc.deepcopy(this.dataFieldList);
              // if (this.type === "HpgeData") {
              //   for(let i in this.realTimeData){
              //     if(this.realTimeData[i].attribute ==='file_name'){
              //       this.spectrogramOptionData.title = this.realTimeData[i].value;
              //     }
              //   }
                  
                  
              // }
              // console.log('spectrogramOptionData',this.spectrogramOptionData)
              resolve(results.data);
            } else {
              // this.$message.error(
              //   results.data.msg ? results.data.msg : "获取设备实时数据失败"
              // );
              reject(null);
            }
          })
          .catch((err) => {
            this.realTimeLoading = false;
          });
      });
    },
    //检查实时数据是否有更新
    inspectRealTimeData() {
      this.$$http("inspectRealTimeData", {
        device: this.id,
        device_data_model: this.type,
      })
        .then((results) => {
          if (results.data && results.status == 200) {
            if (results.data.has_new === true) {
              this.notifys = this.$notify({
                title: "提示",
                message: "有数据更新，点击刷新",
                duration: 10000,
                onClick: () => {
                  this.realTimeLoading = true;
                  
                  // this.optionData = this.pbFunc.deepcopy(this.newOptionData);
                  // console.log('更新实时数据',this.newOptionData.flow.isClass,this.optionData.flow.isClass)
                  this.getRealTimeData(this.deviceType,true);
                  this.notifys.close();
                },
              });
            }
          }
        })
        .catch((err) => {});
    },
    //不同数据类型 选择echart图表间隔时间段
    timeSlot(title, type, number, timeInterval, isEMagnetic) {
      let startTime = "";
      let endTime = "";
      let typeID = type;
      if (number) {
        startTime = this.pbFunc.getDateStr(number + 1);
        endTime = this.pbFunc.getDateStr(1);
      }
      if (isEMagnetic && type === "electric") {
        type = "";
      }

      this.pbFunc
        .echartsData(
          this.id,
          this.type,
          startTime,
          endTime,
          type,
          this.type == "LABRData" && timeInterval == "1m" ? "5m" : timeInterval
        )
        .then((res) => {
          if (res) {
            // console.log("isEMagnetic", res);
            if (isEMagnetic) {
              this.electricIntensity.dataYList = {
                electric: [],
                electric_savg: [],
                electric_avg: [],
              };
              this.electricIntensity.dataX = [];
              this.electricIntensity.isClass = "";
              for (let i in res) {
                this.electricIntensity.dataX.push(res[i].data_time);
                this.electricIntensity.dataYList.electric.push(res[i].electric);
                this.electricIntensity.dataYList.electric_savg.push(
                  res[i].electric_savg
                );
                this.electricIntensity.dataYList.electric_avg.push(
                  res[i].electric_savg
                );
                // this.electricIntensity.dataX.push(res[i].data_time);
              }
              this.electricIntensity.isClass = typeID + "-" + timeInterval;
              this.electricIntensity.titleTime = title;
              this.electricIntensity = Object.assign(
                {},
                this.electricIntensity
              );
              // console.log("电", this.electricIntensity);
              this.setEchart(this.electricIntensity, "EMagneticData2");
            } else {
              this.optionData[type].dataY = [];
              this.optionData[type].dataX = [];
              this.optionData[type].isClass = "";
              for (let i in res) {
                this.optionData[type].dataX.push(res[i].data_time);
                this.optionData[type].dataY.push(res[i][type]);
              }
              this.optionData[type].isClass = type + "-" + timeInterval;
              this.optionData[type].titleTime = title;
              this.setEchart(this.optionData[type]);
              this.optionData = this.pbFunc.deepcopy(Object.assign({}, this.optionData));
              // this.newOptionData =this.pbFunc.deepcopy(Object.assign({}, this.optionData))
              // console.log('切换',this.optionData)
            }
          }
        });
    },
    //设置echart
    setEchart(data, type) {
      data.option.series = []; //清空
      data.option.yAxis.name = data.title + data.unit; //单位
      data.option.xAxis.data = data.dataX; //y轴数据

      if (type === "EMagneticData2") {
        let index = 0; //下标
        data.option.legend.data = data.legend; //展示数据title
        let series = [];
        let color = ["#6495ed", "#c23632", "#61a0a8"]; //折线颜色
        for (let i in data.dataYList) {
          series.push({
            name: data.legend[index],
            type: "line",
            lineStyle: {
              color: color[index],
              width: 2,
            },
            symbol: "circle",
            itemStyle: {
              color: color[index],
            },
            data: data.dataYList[i],
          });
          index++;
        }
        data.option.series = series;
      } else {
        data.option.legend.data = [data.title]; //展示数据title
        data.option.series.push({
          name: data.title,
          type: "line",
          lineStyle: {
            color: "#6495ed",
            width: 2,
          },
          symbol: "circle",

          itemStyle: {
            color: "#6495ed",
          },
          data: data.dataY,
        });
        // console.log("data.option.series", data.option.series);
      }

      this.newEchart = this.$Echarts.init(
        document.getElementById(data.attribute)
      );
      this.newEchart.setOption(data.option);
    },
    //获取高纯锗能谱仪系统设备的最新核素分析报告
    getHpgeData() {
      this.$$http("getHpgeData", {
        id: this.id,
      })
        .then((results) => {
          this.nuclideLoading = false;
          if (results.data && results.status == 200) {
            this.nuclideData = [];
            this.titleNuclideData = [];
            this.nuclideData = results.data.results;
            if (this.nuclideData.length) {
              this.titleNuclideData = [
                {
                  sid: this.nuclideData[0].sid,
                  data_time: this.nuclideData[0].data_time,
                  max_flow: this.nuclideData[0].max_flow,
                },
              ];
            }
            // console.log('titleNuclideData',this.titleNuclideData)
            for (let i in this.nuclideData) {
              this.nuclideData[i].activityStr = this.nuclideData[i].activity
                ? this.nuclideData[i].activity
                : "<探测限";
            }
          }
        })
        .catch((err) => {
          this.nuclideLoading = false;
        });
    },
    //全自动气溶胶 Status 数据
    airosolStatusData(){
      this.airosolStatusLoading = true;
      this.$$http("airosolStatusData", {
        id: this.id,
      })
        .then((results) => {
          this.airosolStatusLoading = false;
          if (results.data && results.status == 200) {
            for(let i in results.data.device_fields){
              this.airosolStatusDataList.push({
                attribute:  results.data.device_fields[i].name,
                name: results.data.device_fields[i].title,
                unit: "",
                value:results.data.data[results.data.device_fields[i].name]
              })
            }
          }
          
        })
        .catch((err) => {
          this.airosolStatusLoading = false;
        });
    },
    //实时谱图
    spectrogramOption(){
      this.spectrogramLoading = true;
      this.$$http("hpgeAtlas", {
        id: this.id,
      })
        .then((results) => {
          this.spectrogramLoading = false;
          if (results.data && results.status == 200) {
            this.spectrogramOptionData.title = results.data.filename;
            for(let i in results.data.data){
              this.spectrogramOptionData.dataX.push(results.data.data[i][0]);
              this.spectrogramOptionData.dataY.push(results.data.data[i][1]);
            }
            // console.log('Status',results.data)
          }
          
        })
        .catch((err) => {
          this.spectrogramLoading = false;
        });
    },
  },
  created() {
    this.getDateil();
    
    if (this.type === "HpgeData") {
      this.getHpgeData();
      this.spectrogramOption();
      this.isDown = true;
      this.isDot = true;
    }else if(this.type ==='AirosolData'){
      this.airosolStatusData();
    }
    this.setIntervalId = setInterval(() => {
      this.inspectRealTimeData();
    }, 10000);
  },
  beforeDestroy() {
    if (this.notifys) {
      this.notifys.close();
    }

    clearInterval(this.setIntervalId);
  },
  
};
</script>



// WEBPACK FOOTER //
// src/pages/automaticStation/classify/system.vue